var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "store_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#store_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M34.607 15.7 32.524 7H7.443l-2.082 8.7c-.354 1.506-.03 3.042.916 4.254.118.162.28.28.414.428v13.205h26.586V20.382c.133-.133.296-.266.414-.414a4.968 4.968 0 0 0 .916-4.268ZM12.628 9.954l-.856 7.178c-.119.96-.887 1.684-1.788 1.684a1.7 1.7 0 0 1-1.373-.694 2.013 2.013 0 0 1-.37-1.728l1.537-6.44h2.85Zm17.562 0 1.551 6.44c.148.62.015 1.24-.37 1.728-.206.266-.649.694-1.387.694-.902 0-1.684-.723-1.788-1.683l-.856-7.179h2.85Zm-5.022 6.676a1.985 1.985 0 0 1-.487 1.58c-.34.385-.812.606-1.418.606-.99 0-1.802-.871-1.802-1.935V9.954h2.895l.812 6.676Zm-6.661.251c0 1.064-.812 1.935-1.905 1.935-.503 0-.96-.221-1.315-.605a2.098 2.098 0 0 1-.487-1.58l.812-6.677h2.895v6.927ZM9.645 30.633v-8.907c.118.015.221.044.34.044a4.622 4.622 0 0 0 3.308-1.403 4.75 4.75 0 0 0 3.412 1.403c1.285 0 2.437-.531 3.294-1.373a4.842 4.842 0 0 0 3.382 1.373c1.24 0 2.422-.517 3.309-1.403a4.622 4.622 0 0 0 3.308 1.403c.118 0 .222-.03.34-.044v8.907H9.645Z"
}))));
export default SvgStore;